import { render, staticRenderFns } from "./CategoriaPecaProfissionalIndependenteForm.vue?vue&type=template&id=097bff36"
import script from "./CategoriaPecaProfissionalIndependenteForm.vue?vue&type=script&lang=js"
export * from "./CategoriaPecaProfissionalIndependenteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports